import React, { Component } from 'react'
import PropTypes from 'prop-types'

import InlineCss from 'react-inline-css'

import { PICTURE_DEBUG, SERVER_URL } from 'Global/constants'
import { isWellShaped } from 'Global/Helpers/objectHelpers'

const styles = `
  .dimmed.dimmable > .ui.animating.dimmer,
  .dimmed.dimmable > .ui.visible.dimmer,
  .ui.active.dimmer {
    background-color: rgb(0, 0, 0);
  }`

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'PreviewModalContainer'

    static propTypes = {
      disableRugInformation: PropTypes.bool,
      expanded: PropTypes.bool.isRequired,
      index: PropTypes.number.isRequired,
      open: PropTypes.bool.isRequired,
      rugs: PropTypes.array.isRequired,
      setCurrentIndex: PropTypes.func.isRequired,
      toggle: PropTypes.func.isRequired,
      toggleExpansion: PropTypes.func.isRequired,
    }

    static defaultProps = {
      disableRugInformation: false,
    }

    currentPicture = () => {
      const { rugs, index } = this.props

      if (index > -1) {
        const rug = rugs[index]

        if (isWellShaped(rug, 'pictureBig')) {
          if (PICTURE_DEBUG) {
            return PICTURE_DEBUG
          } else {
            return `${SERVER_URL}${rug.pictureBig}`
          }
        }
      }

      return ''
    }

    currentRug = () => {
      const { rugs, index } = this.props

      return rugs[index] || {}
    }

    handleClickLeft = () => {
      const { index } = this.props

      this.setCurrentIndex(index - 1)
    }

    handleClickRight = () => {
      const { index } = this.props

      this.setCurrentIndex(index + 1)
    }

    handleKeyDown = e => {
      if (e === 37) {
        if (this.previousPicture()) {
          this.handleClickLeft()
        }
      } else if (e === 39) {
        if (this.nextPicture()) {
          this.handleClickRight()
        }
      }
    }

    nextPicture = () => {
      const { index, rugs } = this.props

      if (index > -1) {
        const rug = rugs[index + 1]

        if (isWellShaped(rug, 'pictureBig')) {
          return true
        }
      }

      return false
    }

    previousPicture = () => {
      const { index, rugs } = this.props

      if (index > -1) {
        const rug = rugs[index - 1]

        if (isWellShaped(rug, 'pictureBig')) {
          return true
        }
      }

      return false
    }

    setCurrentIndex = index => {
      const { setCurrentIndex } = this.props

      setCurrentIndex(index)
    }

    render() {
      const { disableRugInformation, expanded, open, toggle, toggleExpansion } = this.props

      const currentPicture = this.currentPicture()
      const currentRug = this.currentRug()
      const next = this.nextPicture()
      const previous = this.previousPicture()

      return (
        <div>
          {expanded ? <InlineCss stylesheet={styles} /> : null}

          <WrappedComponent
            currentPicture={currentPicture}
            currentRug={currentRug}
            disableRugInformation={disableRugInformation}
            expanded={expanded}
            handleClickLeft={this.handleClickLeft}
            handleClickRight={this.handleClickRight}
            handleKeyDown={this.handleKeyDown}
            next={next}
            open={open}
            previous={previous}
            toggle={toggle}
            toggleExpansion={toggleExpansion}
          />
        </div>
      )
    }
  }

  return Container
}
